import { Injectable } from "@angular/core"
import { ApiService } from "app/shared/services/api.service"
import { Observable } from "rxjs"
import { HotelAddOnDTO, HotelAddOnsDTO } from "./models/hotel-add-ons"
import { HotelWifiDTO } from "./models/hotel-wifi"
const API_V1 = "service/"
const API_V2 = "serviceV2/"
const API_V3 = "serviceV3/"

const API_SERVICE = {
  HOTEL_WIFI: API_V3 + "HotelWifi/",
  HOTEL_ADDONS: API_V3 + "HotelAddOns/",
}

@Injectable({
  providedIn: "root",
})
export class ServiceApiService {
  constructor(private apiService: ApiService) {}

  /** AddOns */
  private $addOnIcons: Observable<string[]>

  public V3HotelWifi = {
    /** Update the hotel Wifi for hotel */
    Update: (wifi: HotelWifiDTO): Observable<void> => this.apiService.put<void>(`${API_SERVICE.HOTEL_WIFI}`, wifi),
    /** Get the hotel wifi settings in flow */
    GetAdmin: (hotelId: string): Observable<HotelWifiDTO> => this.apiService.get<HotelWifiDTO>(`${API_SERVICE.HOTEL_WIFI}Admin/${hotelId}`),
  }

  public V3HotelAddOn = {
    /** Update the hotel Add-ons */
    Update: (addOns: HotelAddOnsDTO, employeeName: string): Observable<HotelAddOnDTO[]> => this.apiService.put<HotelAddOnDTO[]>(`${API_SERVICE.HOTEL_ADDONS}?employeeName=${employeeName}`, addOns),
    /** Get all hotel Add-ons for given hotel */
    GetAdmin: (hotelId: string): Observable<HotelAddOnsDTO> => this.apiService.get<HotelAddOnsDTO>(`${API_SERVICE.HOTEL_ADDONS}Admin/${hotelId}`),
    /** Get all add-on icons from azure blob storage */
    GetIcons: (): Observable<string[]> => (this.$addOnIcons ??= this.apiService.get<string[]>(`${API_SERVICE.HOTEL_ADDONS}Icons`)),
    /**Get all hotel directory icons from azure blob storage */
    GetHDIcons: (): Observable<string[]> => (this.$addOnIcons ??= this.apiService.get<string[]>(`${API_SERVICE.HOTEL_ADDONS}Icons/HD`)),
  }
}
